module.exports = __webpack_public_path__ + "static/springkraf-logo-light-0b0f764b8987ec62945121b0d4597085.png";